<script src="../../logistics/channelDepartment/listCountryPrice.js"></script>
<template>
  <el-dialog class="increaseWaybill" width="70%" title="国际运单" :visible.sync="dialogVisible" append-to-body
             @close="closeComponents">
    <el-form :model="formInner" ref="formInner" :rules="formInnerRules" class="custom-formItem" inline
             label-width="120px">
      <el-form-item label="产品中文" prop="cname">
        <el-input placeholder="请输入" v-model="formInner.cname"></el-input>
      </el-form-item>
      <el-form-item label="海关品名(英文)" prop="ename">
        <el-input placeholder="请输入" v-model="formInner.ename"></el-input>
      </el-form-item>
      <el-form-item label="海关编号(HS)" prop="hscode">
        <template slot="label">
          <el-link type="primary" href="https://www.hsbianma.com/" :underline="false" target="_blank">海关编号(HS)</el-link>
        </template>
        <el-input placeholder="请输入" v-model.trim="formInner.hscode" onkeyup="value=value.replace(/[^\d.]/g,'')"></el-input>
      </el-form-item>
      <el-form-item label="申报数量" prop="quantity">
        <el-input placeholder="请输入" v-model="formInner.quantity"></el-input>
      </el-form-item>
      <el-form-item label="申报单价" prop="unitPrice">
        <el-input placeholder="请输入" v-model="formInner.unitPrice"></el-input>
      </el-form-item>
      <el-form-item label="申报总值" prop="goodDeclareWorth">
        <el-input placeholder="请输入" v-model="formInner.goodDeclareWorth"></el-input>
      </el-form-item>
      <el-form-item label="申报重量" prop="goodsWeight">
        <el-input placeholder="请输入" v-model="formInner.goodsWeight"></el-input>
      </el-form-item>
      <el-form-item label="申报体积" required>
        <el-row type="flex" justify="space-between" align="middle">
          <el-form-item prop="goodsLength" class="w100">
            <el-input placeholder="长" v-model="formInner.goodsLength"></el-input>
          </el-form-item>
          <div style="padding:0 10px;">X</div>
          <el-form-item prop="goodsWidth" class="w100">
            <el-input placeholder="宽" v-model="formInner.goodsWidth"></el-input>
          </el-form-item>
          <div style="padding:0 10px;">X</div>
          <el-form-item prop="goodsHeight" class="w100">
            <el-input placeholder="高" v-model="formInner.goodsHeight"></el-input>
          </el-form-item>
        </el-row>
      </el-form-item>
      <el-form-item label="物流" required style="width: 50%;">
        <el-row type="flex" align="middle">
          <el-form-item prop="type" class="w100" style="margin-right: 10px;">
            <el-select v-model="formInner.type" @change="selectChange" filterable value-key="channelType">
              <el-option v-for="item in listLogistics" :key="item.id" :label="logisticsType[item.channelType]"
                         :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="shippingMethod" class="w100" style="margin-right: 10px;">
            <el-select v-model="formInner.shippingMethod" filterable value-key="value"
                       @change="selectChange($event, 'channel')">
              <el-option v-for="item in logisticsTwoList" :key="item.id" :label="item.title" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-button type="primary" @click="createWaybill" :loading="loadingCreateWaybill">生成运单</el-button>
        </el-row>
      </el-form-item>
      <el-form-item label="申报SKU" prop="sku" style="width: 50%;">
        <el-row type="flex" align="middle">
          <el-input v-model="formInner.sku"></el-input>
        </el-row>
      </el-form-item>

      <el-form-item label="运单">
        <el-input readonly v-model="conveyNumber"></el-input>
      </el-form-item>
      <el-form-item label="追踪">
        <el-input readonly v-model="trackNumber"></el-input>
      </el-form-item>
    </el-form>

    <template slot="footer">
      <el-button type="primary" @click="submitDone" :loading="loadingDone">完 成</el-button>
    </template>
  </el-dialog>
</template>

<script>
import { ajaxPost, Baseurl } from '@/api/api/api'
import listCountryPrice from '../../logistics/channelDepartment/listCountryPrice'

export default {
  name: 'IncreaseWaybill',
  data() {
    return {
      dialogVisible: false,
      infoData: {},
      logisticsType: {
        1: '三态',
        2: '云途',
        3: '燕文',
        5: '辰达通',
        6: '递四方',
        7: '云途（服装）',
        8: '泰嘉',
        9: '八达通',
      },
      listLogistics: [],
      logisticsTwoList: [],
      formInner: {
        type: "",
        shippingMethod: "",
        cname: "",
        ename: "",
        hscode: "",
        quantity: "1",
        unitPrice: "",
        goodDeclareWorth: "1",
        goodsWeight: "1",
        goodsLength: "1",
        goodsWidth: "1",
        goodsHeight: "1",
        productUrl: "",
        sku: '',
      },
      formInnerRules: {
        type: [{ required: true, message: "物流选择有误", trigger: "change" }],
        shippingMethod: [{ required: true, message: "物流选择有误", trigger: "change" }],
        cname: [{ required: true, message: "产品中文输入有误", trigger: "blur" }],
        ename: [{ required: true, message: "海关品名(英文)输入有误", trigger: "blur" }],
        hscode: [{ required: true, message: "海关编号(HS)输入有误", trigger: "blur" }],
        quantity: [{ required: true, message: "申报数量输入有误", trigger: "blur" }],
        unitPrice: [{ required: true, message: "申报单价输入有误", trigger: "blur" }],
        goodDeclareWorth: [{ required: true, message: "申报总值输入有误", trigger: "blur" }],
        goodsWeight: [{ required: true, message: "申报重量输入有误", trigger: "blur" }],
        goodsLength: [{ required: true, message: "长度输入有误", trigger: "blur" }],
        goodsWidth: [{ required: true, message: "宽度输入有误", trigger: "blur" }],
        goodsHeight: [{ required: true, message: "高度输入有误", trigger: "blur" }],
        productUrl: [{ required: true, message: "销售链接输入有误", trigger: "blur" }],
        // sku: [{ required: true, message: "sku有误", trigger: "blur" }],
      },
      loadingCreateWaybill: false,
      loadingDone: false,

      conveyNumber: '',
      trackNumber: '',
      roleId: '',
    }
  },
  computed: {
    infoAddress() {
      return this.infoData.address || {};
    },
  },
  methods: {
    openComponents(data) {
      console.log(data)
      this.infoData = data
      this.roleId = JSON.parse(localStorage.getItem('role')).rid
      this.getOrderMoney().then(code => {
        if (code === 200) {
          this.getListLogistics()

          this.formInner.productUrl = this.infoData.orderItems[0].saleLink;
          // this.formInner.sku = this.infoData.orderItems[0].sellerSKU;
          this.formInner.sku = '';
          this.formInner.unitPrice = listCountryPrice[this.infoData.countryMark] || "17";
          this.formInner.goodDeclareWorth = this.formInner.unitPrice * this.formInner.quantity;
          this.dialogVisible = true
        }
      }).catch((err) => {
        this.$message.error(err || '网络出现问题，请稍候')
      })
    },
    closeComponents() {
      this.formInner = this.$options.data().formInner;
      this.$refs.formInner.clearValidate();
      this.$emit('close')
    },
    // 查询是否余额不足
    getOrderMoney() {
      return new Promise((resolve, reject) => {
        const API = Baseurl + 'logisticsController/selectCompanyBalanceByOrder'
        const paramsData = { orderId: this.infoData.orderId }
        ajaxPost(API, paramsData).then(res => {
          const { code, data } = res.data
          if (code === 200) {
            resolve(code)
          } else {
            reject(data)
          }
        })
      })
    },
    // 获取物流列表
    getLogisticsList() {
      const API = Baseurl + "purchaseController/selectItemList";
      const paramsData = {
        itemCode: "HYXUN0000007",
      };
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          this.listLogistics = data;
        }
      });
    },

    selectChange(item, selectType) {
      console.log(item)
      this.conveyNumber = "";
      this.trackNumber = "";
      if (selectType === "channel") return;
      this.formInner.shippingMethod = "";
      const { channelType: type } = item;
      const API = Baseurl + "logisticsController/getShippingMethodList";
      const paramsData = { type };
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          let itemTitleKey = "";
          let itemValueKey = "";
          if (type === 1) {
            itemTitleKey = "cnName";
            itemValueKey = "methodCode";
          } else if (type === 2) {
            itemTitleKey = "cname";
            itemValueKey = "code";
          } else if (type === 3) {
            itemTitleKey = "name";
            itemValueKey = "id";
          } else if (type === 5) {
            itemTitleKey = "cnName";
            itemValueKey = "code";
          }
          if (!itemTitleKey) return;
          this.logisticsTwoList = [];
          data.forEach(item => {
            const itemObj = {
              id: item.id || item.ytId,
              title: item[itemTitleKey],
              value: item[itemValueKey],
            };
            this.logisticsTwoList.push(itemObj);
          });
        }
      });
    },

    getListLogistics() {
      const API = Baseurl + 'channelSecretController/getChannelSecretListByCompanyId'
      const paramsData = { companyId: this.infoData.companyId }
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          this.listLogistics = data;
        }
      });
    },

    createWaybill() {
      if (!this.infoAddress.phone) {
        this.$message.error('缺少TEL')
        return
      }
      this.$refs.formInner.validate(valid => {
        if (!valid) return;
        const API = Baseurl + "logisticsController/applyConveyNumber";
        const { channelType } = this.formInner.type;
        const paramsData = {
          customerOrderNumber: this.infoData.customerOrderNo,
          orderId: this.infoData.id,
          memo: "",
          type: channelType,
          shippingMethod: this.formInner.shippingMethod.value,
          applyFromStatus: 2,
          receiver: {
            countryCode: this.infoAddress.countryCode1,
            firstName: this.infoAddress.name,
            lastName: this.infoAddress.name,
            company: "",
            street: "",
            city: this.infoAddress.city || '',
            state: this.infoAddress.stateOrRegion || "",
            phone: this.infoAddress.phone,
            houseNumber: "",
            email: this.infoData.buyerEmail,
            streetAddress1: this.infoAddress.addressLine1 || "",
            streetAddress2: this.infoAddress.addressLine2 || "",
            streetAddress3: this.infoAddress.addressLine3 || "",
            postcode: this.infoAddress.postalCode,
          },
          sender: {
            countryCode: this.infoData.countryMark,
            firstName: this.infoData.buyerName,
            lastName: this.infoData.buyerName,
            company: "",
            street: "",
            city: "",
            state: "",
            zip: "",
            phone: "",
            houseNumber: "",
          },
          parcels: {
            // sku: this.infoData.orderItems[0].sellerSKU,
            invoiceRemark: "",
            currencyCode: "USD",
            boxWeight: "",
            unitWeight: "1",
            ...this.formInner,
          },
        };
        // 判断州 市是否有值，没有的话就互相赋值
        if (!paramsData.receiver.city || !paramsData.receiver.state) {
          if (!paramsData.receiver.city) {
            paramsData.receiver.city = paramsData.receiver.state
          }
          if (!paramsData.receiver.state) {
            paramsData.receiver.state = paramsData.receiver.city
          }
        }
        if (channelType === 3) paramsData.shippingMethod = this.formInner.shippingMethod.id
        // paramsData.shippingMethod =
        this.loadingCreateWaybill = true;
        ajaxPost(API, paramsData).then(res => {
          const { code, data } = res.data;
          this.loadingCreateWaybill = false;
          if (code === 200) {
            try {
              // 1 三态 2 云途 3 燕文 5 辰达通
              if (channelType === 1) {
                this.conveyNumber = data.orderCode;
                this.trackNumber = data.trackingNumber;
                this.channelId = data.orderChannelId;
              } else if (channelType === 2) {
                this.conveyNumber = data.item[0].wayBillNumber;
                this.trackNumber = data.item[0].trackingNumber;
                this.channelId = data.item[0].orderChannelId;
              } else if (channelType === 3) {
                this.conveyNumber = data.conveyNumber;
                this.trackNumber = data.trackNumber;
                this.channelId = data.orderChannelId;
              } else if (channelType === 5) {
                this.conveyNumber = data.returnDatas[0].corpBillid;
                this.trackNumber = data.returnDatas[0].trackNumber;
                this.channelId = data.returnDatas[0].customerNumber;
              }
              this.applyFromStatus = data.applyFromStatus
              this.isCreateWaybill = true;
              this.$message.success("操作成功");
            } catch (error) {
              console.log(error)
              this.$message.error("生成超时");
            }
          } else if (code === 500) {
            if (channelType === 3) {
              this.$message.warning(data.reasonMessageElm);
              return;
            }
            this.$message.warning(data);
          } else {
            this.$message.warning(data);
          }
        });
      });
    },
    addWaybillDone() {
      if (!this.isCreateWaybill) {
        this.$message.warning("请先生成运单！");
        return;
      }
      if (!this.conveyNumber) {
        this.$message.warning("运单号有误！");
        return;
      }
      const API = Baseurl + "logisticsController/insertOrderChannel";
      const {
        type: { channelType: type },
        shippingMethod: { title: channelWay },
        cname: productChineseName,
        ename: productEnglishName,
        hscode: customsNo,
        quantity: applyCount,
        unitPrice: applyPrice,
        goodDeclareWorth: applyTotal,
        goodsWeight: applyWeight,
        productUrl: sellLink,
        goodsLength,
        goodsWidth,
        goodsHeight,
      } = this.formInner;
      const applyVolume = Number(goodsLength) * Number(goodsWidth) * Number(goodsHeight);
      const paramsData = {
        roleId: this.roleId,
        // companyId: this.infoData.companyId,
        orderId: this.infoData.id,
        channelName: this.logisticsType[type],
        channelWay,
        type,
        productChineseName,
        productEnglishName,
        customsNo,
        applyCount,
        applyPrice,
        applyTotal,
        applyWeight,
        applyVolume,
        sellLink,
        conveyNumber: this.conveyNumber,
        trackNumber: this.trackNumber,
        actualWeight: "",
        status: "0",
        orderChannelId: this.channelId,
        destinationCountryMark: this.infoData.address.countryCode1,
        applyFromStatus: this.applyFromStatus,
      };
      this.loadingDone = true
      ajaxPost(API, paramsData).then(res => {
        const { code } = res.data;
        this.loadingDone = false
        if (code === 200) {
          this.$message.success("操作成功");
          this.dialogVisible = false;
          this.conveyNumber = "";
          this.trackNumber = "";
          this.$emit('refreshData')
        } else {
          this.$message.warning("操作失败");
        }
      });
    },
    submitDone() {
      this.addWaybillDone()
    },
  },
}
</script>

<style lang="scss" scoped>
.increaseWaybill {
  .custom-formItem {
    ::v-deep {
      .el-form-item {
        width: 33.333%;
        margin-right: 0;
      }

      .el-form-item__content {
        width: calc(100% - 120px);

        .el-select,
        .el-date-editor,
        .el-input {
          width: 100%;
        }
      }

      .w100 {
        width: 100%;

        .el-form-item__content {
          width: 100%;
        }
      }
    }
  }
}
</style>
